import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { MbonusPopup } from 'widgets/mbonus-content/components/mbonus-popup/mbonus-popup'

import { priceShow } from 'shared/lib/priceShow'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { MBonusIcons } from 'shared/ui/mbonus/mbonus-icons'

import s from './styles.module.scss'

interface Props {
  bonus: string | undefined
  isTransparent?: boolean
}

export const MbonusLineInfo = ({ bonus, isTransparent }: Props) => {
  const { t } = useTranslation()

  const { openDialog } = useDialogBottomSheet()

  const onClick = () => {
    openDialog({
      child: <MbonusPopup />,
      isDialog: false,
    })
  }

  if (!parseInt(bonus || '0')) {
    return
  }
  return (
    <div className={clsx({ [s.transparent]: isTransparent }, s.bonuses)}>
      <div
        className={s.text}
        onClick={onClick}
      >
        <p className={clsx(s.bonusDescription, 'regular-12')}>
          {t('cashback')}
        </p>

        <AppIcon
          id={AllIcons.INFO}
          width={13}
          height={12}
          className={s.info}
        />
      </div>

      <MBonusIcons
        text={priceShow(bonus)}
        onClick={onClick}
      />
    </div>
  )
}
